import { html } from "lit";
import { u } from "@converse/headless";

/**
 * @param {string} video_id - The YouTube video ID.
 * @param {string} url - The URL to link to (if not hidden).
 * @param {boolean} hide_url - Flag to determine if the URL should be hidden.
 * @returns {import('lit').TemplateResult}
 */
export default (video_id, url, hide_url) => {
    const { hostname } = u.getURL(url);
    return html`<figure><iframe style="border-radius:12px" src="https://www.youtube.com/embed/${video_id}" width="100%" height="315" frameborder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>${hide_url ? "" : html`<a target="_blank" rel="noopener" title="${url}" href="${url}">${hostname}</a>`}</figure>`;
};
